/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_SubmitInputs */

const en_directory_search_submit = /** @type {(inputs: Directory_Search_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const pl_directory_search_submit = /** @type {(inputs: Directory_Search_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Directory_Search_SubmitInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_submit = /** @type {((inputs?: Directory_Search_SubmitInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_SubmitInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_submit(inputs)
	return en_directory_search_submit(inputs)
});